import { ChangeEvent } from 'react';

export const handleImageChange = (e: ChangeEvent<HTMLInputElement>, cb: (path: string) => void) => {
  const file = e.target.files ? e.target.files[0] : null;
  if (file) {
    const reader = new FileReader();
    reader.onload = (event: ProgressEvent<FileReader>) => {
      cb(event.target?.result as string);
    };
    reader.readAsDataURL(file);
  }
};
